import { Component, EventEmitter, Input, OnInit, Optional, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MatDialogRef } from '@angular/material/dialog';
import { UserChangePasswordDto, UserDto, AccountService, NotificationService, OAuthServiceService, TenantService, TranslateService } from 'shared';

@Component({
    selector: 'user-change-password',
    templateUrl: './user-change-password.component.html',
    styleUrls: ['./user-change-password.component.scss'],
    standalone: false
})
export class UserChangePasswordComponent implements OnInit {
  @Input('user') user!: UserDto;
  @Output() onChangePassword: EventEmitter<string> = new EventEmitter();

  passwordForm!: UntypedFormGroup;
  userId!: string;
  userName!: string;
  userEmail!: string;
  forceChangPw = false;
  passwortAltVerbergen = true;
  passwortNeuVerbergen = true;

  constructor(private formBuilder: UntypedFormBuilder,
    private router: Router,
    private tenantService: TenantService,
    private oauthService: OAuthServiceService,
    private accountService: AccountService,
    public translate: TranslateService,
    private notificationService: NotificationService,
    @Optional() public dialogRef: MatDialogRef<UserChangePasswordComponent>) { }

  ngOnInit(): void {
    (this.user != null) ? this.forceChangPw = true : this.forceChangPw = false;
    this.createForm();
  }

  createForm() {
    this.oauthService.userData.subscribe({
      next: (data) => {
        const newUserId = (data as any)?.sub;
        // buildPasswordForm haengt von userId/userName ab, userData kommt asynchron -
        // der fruehere synchrone Aufruf direkt nach dem subscribe lief immer mit leeren Werten
        if (!newUserId || newUserId === this.userId) return;
        this.userId = newUserId;
        this.userName = (data as any)?.name;
        this.userEmail = (data as any)?.email;
        this.buildPasswordForm(this.userId, this.userName);
      }
    });
  }

  buildPasswordForm(userId: string, userName: string) {
    let pwregex: RegExp = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@$!%*#?&^_-]).{8,}/

    if (this.forceChangPw) {
      this.passwordForm = this.formBuilder.group({
        userId: [userId],
        userName: [userName],
        oldPassword: [null],
        password: [null, [Validators.required, Validators.pattern(pwregex)]],
        confirmPassword: [null, [Validators.required, Validators.pattern(pwregex)]]
      });
    } else {
      this.passwordForm = this.formBuilder.group({
        userId: [userId],
        userName: [userName],
        oldPassword: [null, [Validators.required, Validators.pattern(pwregex)]],
        password: [null, [Validators.required, Validators.pattern(pwregex)]],
        confirmPassword: [null, [Validators.required, Validators.pattern(pwregex)]]
      });
    }
  }

  cancel() {
    // Als Dialog geoeffnet (z.B. ueber das Header-Menue): schliessen statt navigieren.
    // Als geroutete Seite / eingebettetes Formular (z.B. check-userlogin): wie bisher navigieren.
    if (this.dialogRef) {
      this.dialogRef.close();
      return;
    }
    if (this.tenantService.currentTenantName == this.tenantService.SystemManagerAbbreviation) this.router.navigate(['/', this.tenantService.currentTenantName, 'manage-tenants']);
    else this.router.navigate(['/', this.tenantService.currentTenantName, 'all-projects']);
  }

  changePassword() {
    if (this.passwordForm.valid) {
      let changePassword = new UserChangePasswordDto;
      changePassword.userId = this.passwordForm.value.userId;
      changePassword.password = this.passwordForm.value.password;
      changePassword.confirmPassword = this.passwordForm.value.confirmPassword;
      if (!this.forceChangPw) {
        //old password is checked backend-side before the change is applied
        changePassword.oldPassword = this.passwordForm.value.oldPassword;
      }

      if (changePassword.password === changePassword.confirmPassword) {
        this.accountService.changePassword(changePassword).subscribe({
          next: (x) => {
            this.notificationService.success(`${this.translate.data["SUCCESS"]}`, `${this.translate.data["USERPASSWORDUPADTED"]}`);
            if (!this.forceChangPw) {
              //forced first-login change stays on the page so the parent (check-userlogin) can transition to the next step
              if (this.dialogRef) {
                this.dialogRef.close();
              } else if (this.tenantService.currentTenantName == this.tenantService.SystemManagerAbbreviation) {
                this.router.navigate(['/', this.tenantService.currentTenantName, 'manage-tenants']);
              } else {
                this.router.navigate(['/', this.tenantService.currentTenantName, 'all-projects']);
              }
            }
            this.onChangePassword.emit("changed");
          },
          error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, error?.error ?? `${this.translate.data["USERPASSWORDUPADTEDERROR"]}`)
        });
      } else {
        this.notificationService.warning(`${this.translate.data["WARN"]}`, `${this.translate.data["DIFERENTPASSWORDS"]} Password : ${changePassword.password} ConfirmPassword : ${changePassword.confirmPassword}`);
      }
    }
  }
}
